var OrientationAxis;
(function (OrientationAxis) {
    OrientationAxis["AXIAL"] = "axial";
    OrientationAxis["CORONAL"] = "coronal";
    OrientationAxis["SAGITTAL"] = "sagittal";
    OrientationAxis["ACQUISITION"] = "acquisition";
    OrientationAxis["AXIAL_REFORMAT"] = "axial_reformat";
    OrientationAxis["CORONAL_REFORMAT"] = "coronal_reformat";
    OrientationAxis["SAGITTAL_REFORMAT"] = "sagittal_reformat";
    OrientationAxis["REFORMAT"] = "reformat";
})(OrientationAxis || (OrientationAxis = {}));
export default OrientationAxis;
